import { Type } from 'react-bootstrap-table2-editor';
import store from '../../../../../store';
import { addTeamsError, clearUpdateTeamErrors } from '../../../../../Redux/Actions/Contract.Teams.Actions';
import * as Helpers from '../Helpers/DatatableHelpers';
import * as DataFormat from '../../../../../Common/Scripts';
import { dateEditRenderer } from '../Helpers/Editors';

const emailRegEx = new RegExp(/^(?!.{201})([\w\W-]+@([\w\W-]+\.)+[\w-]+)$/);

const ContractTeams = (templateData, onStartEdit) => [
	{ dataField: 'id_type', text: 'id_type', hidden: true, csvExport: false },
	{
		dataField: 'type',
		text: 'Type',
		editable: false,
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide'
	},
	{ dataField: 'markingTeamId', text: 'ID', hidden: true },
	{
		dataField: 'title',
		text: 'Marking Team Title',
		sort: true,
		headerClasses: 'th-title-td',
		editable: false
	},
	{
		dataField: 'markingTeamCode',
		text: 'Code',
		sort: true,
		headerClasses: 'th-td-sm',
		classes: 'tr-td-overflow-hide',
		editable: false,
		csvType: 'string',
		csvFormatter: cell => DataFormat.writeDataWithLeadingZeroInCsv(cell)
	},
	{
		dataField: 'displayStatus',
		text: 'Ready for Approval',
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide',
		editable: (content, row, rowIndex, columnIndex) => Helpers.setStatusEditableAsPerIssued(content, row, rowIndex, columnIndex),
		formatter: Helpers.displayStatusFormatter,
		editor: {
			type: Type.SELECT,
			getOptions: () => [
				{ label: '', value: '' },
				{ label: 'Pending', value: 'Pending' },
				{ label: 'On Hold', value: 'On Hold' },
				{ label: 'Ready', value: 'Ready' }
			]
		}
	},
	{
		dataField: 'markingMethodCurrentYear',
		text: 'Marking Method',
		headerClasses: 'th-td-mms',
		validator: newVal => {
			let validator = Helpers.fieldLengthValidation(newVal);
			if (!validator.valid) store.dispatch(addTeamsError([`Marking Team Method: ${validator.message}`]));
			return validator;
		}
	},
	{ dataField: 'templateId', text: 'Template ID', hidden: true, csvExport: false },
	{
		dataField: 'templateName',
		text: 'Template Name',
		headerClasses: 'th-td-lg',
		formatter: Helpers.templateFormatter,
		formatExtraData: { templateData },
		editor: {
			type: Type.SELECT,
			getOptions: () => templateData
		}
	},
	{
		dataField: 'contractTypeName',
		text: 'Contract Type',
		editable: false,
		headerClasses: 'th-title-td'
	},
	{
		dataField: 'contractReleaseDate',
		text: 'Release Date',
		headerClasses: 'th-td-ml',
		sort: true,
		formatter: Helpers.formatDateInput,
		editorRenderer: dateEditRenderer(onStartEdit, 'Release Date'),
		csvFormatter: cell => Helpers.formatDateInput(cell),
		validator: (newValue, row, column) => {
			let validator = Helpers.validateReleaseDate(newValue, row, column);
			if (!validator.valid) {
				store.dispatch(addTeamsError([`Release Date: ${validator.message}`]));
				validator.message = 'Field is invalid.';
			} else {
				store.dispatch(clearUpdateTeamErrors());
				validator.message = '';
			}
			return validator;
		}
	},
	{
		dataField: 'contractEndDate',
		text: 'End Date',
		headerClasses: 'th-td-ml',
		sort: true,
		formatter: Helpers.formatDateInput,
		editorRenderer: dateEditRenderer(onStartEdit, 'End Date'),
		csvFormatter: cell => Helpers.formatDateInput(cell),
		validator: (newValue, row, column) => {
			let validator = Helpers.validateEndDate(newValue, row, column);
			if (!validator.valid) {
				store.dispatch(addTeamsError([`End Date: ${validator.message}`]));
				validator.message = 'Field is invalid.';
			} else {
				store.dispatch(clearUpdateTeamErrors());
				validator.message = '';
			}
			return validator;
		}
	},
	{
		dataField: 'emailAddress',
		text: 'Team Email',
		headerClasses: 'th-title-td',
		sort: true,
		validator: email => {
			let validator =
				email.length <= 0
					? { valid: true }
					: email.length > 200
					? { valid: false, message: 'Field too long' }
					: emailRegEx.test(email)
					? { valid: true }
					: { valid: false, message: `Email Address is invalid` };
			if (!validator.valid) store.dispatch(addTeamsError([`Marking Team Email: ${validator.message}`]));
			return validator;
		}
	}
];

export default ContractTeams;
